/**CORE LIBRARIES IMPORT */
import React, { useState } from "react";
import { Link } from "react-router-dom";

/**ICONS IMPORT */
import { FiMenu, FiX, FiPhone, FiMail, FiMapPin } from "react-icons/fi";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <div className="fixed-header">

        {/* TOP BAR */}
        <div className="top-wrapper">
          <div className="top-bar">
            <div className="top-bar-inner">
              <p className="top-left-text">
                <FiMapPin style={{ marginRight: '5px', verticalAlign: 'middle' }} />
                <span>Metal Manufacturer in India — Ahmedabad, Gujarat</span>
              </p>
              <p className="top-right-text">
                <a href="tel:+918511698600"><FiPhone style={{ marginRight: '4px', verticalAlign: 'middle' }} />+91 85116 98600</a> |{" "}
                <a href="tel:+918511696999">+91 85116 96999</a> |{" "}
                <a href="mailto:jkmetal801@gmail.com"><FiMail style={{ marginRight: '4px', verticalAlign: 'middle' }} />jkmetal801@gmail.com</a>
              </p>
            </div>
          </div>
        </div>

        {/* MAIN HEADER */}
        <header className="main-header">
          <div className="header-inner">

            {/* LOGO - Simple Text JK as requested */}
            <div className="logo-text">
              <Link to="/" className="brand-logo-link">
                <span className="logo-badge">JK</span>
                <div className="logo-text-group">
                  <span className="logo-main-text">JK METAL</span>
                  <span className="logo-sub-text">&amp; ALLOYS</span>
                </div>
              </Link>
            </div>

            {/* DESKTOP NAV */}
            <nav className="nav-links">
              {[
                { label: "Home", path: "/" },
                { label: "About Us", path: "/about" },
                { label: "Products", path: "/products" },
                { label: "Applications", path: "/applications" },
                { label: "Gallery", path: "/gallery" },
                { label: "Contact Us", path: "/contact-us" },
              ].map((item, i) => (
                <Link key={i} to={item.path}>
                  {item.label}
                </Link>
              ))}
            </nav>

            {/* DESKTOP CTA */}
            <Link to="/product-enquiry">
              <button className="enquire-btn">
                Get Instant Quote
              </button>
            </Link>

            {/* MOBILE MENU BUTTON */}
            <button
              className="menu-btn"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              {menuOpen ? <FiX /> : <FiMenu />}
            </button>
          </div>
        </header>
      </div>

      {/* ================= MOBILE SIDEBAR ================= */}
      <div className={`mobile-sidebar ${menuOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={() => setMenuOpen(false)}>
          <FiX />
        </button>

        <div className="sidebar-logo">
          <Link to="/" onClick={() => setMenuOpen(false)}>
            <span className="logo-badge">JK</span> JK Metal
          </Link>
        </div>

        <p className="sidebar-top-text">
          Trusted Metal Manufacturer &amp; Supplier Across India
        </p>

        <nav className="sidebar-nav">
          {[
            { label: "Home", path: "/" },
            { label: "About Us", path: "/about" },
            { label: "Products", path: "/products" },
            { label: "Applications", path: "/applications" },
            { label: "Gallery", path: "/gallery" },
            { label: "Contact Us", path: "/contact-us" },
          ].map((item, i) => (
            <Link key={i} to={item.path} onClick={() => setMenuOpen(false)}>
              {item.label}
            </Link>
          ))}
        </nav>

        <Link to="/product-enquiry" className="sidebar-cta" onClick={() => setMenuOpen(false)}>
          Get Instant Quote
        </Link>
      </div>
      {/* OVERLAY */}
      {menuOpen && <div className="sidebar-overlay" onClick={() => setMenuOpen(false)} />}
    </>
  );
};

export default Header;
